import { Dispatch } from 'redux';
import actions from './actionTypes';
import {
  getTrendingSearches,
  getSearchSuggestions,
  getPopularSuggestions,
  getBulkProducts,
} from './service';
import { logger } from 'shared/logging';
import actionTypes from './actionTypes';
import { getWidgets } from 'store/adPlatform/service';

export const fetchSearchSuggestion =
  (searchTerm: string, isPro: boolean) => (dispatch: Dispatch) => {
    if (searchTerm) {
      return getSearchSuggestions(searchTerm, isPro)
        .then((res) => {
          const { searchInput, suggestions } = res;
          dispatch({
            type: actions.FETCH_SEARCH_SUGGESTION,
            payload: suggestions,
            searchInput,
          });
        })
        .catch((e) => {
          logger.error(e, 'Error in fetch search suggestions');
          throw e;
        });
    } else {
      return new Promise((resolve) => {
        dispatch({
          type: actions.FETCH_SEARCH_SUGGESTION,
          payload: [],
        });
        resolve();
      });
    }
  };

export const fetchTrendingSearches = () => (dispatch: Dispatch) =>
  getTrendingSearches()
    .then((res) => {
      dispatch({
        type: actions.FETCH_TRENDING_SEARCHES,
        payload: res,
      });
    })
    .catch((e) => {
      // TODO: LOG ME
      throw e;
    });

export const updateSearchField = (payload: string) => (dispatch: Dispatch) => {
  dispatch({
    type: actions.UPDATE_SEARCH_FIELD,
    payload,
  });
};

export const resetSearch = () => (dispatch: Dispatch) => {
  dispatch({
    type: actions.RESET_SEARCH,
  });
};

export const toggleVoiceModal =
  (payload: boolean = true) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: actions.TOGGLE_VOICE_Modal,
      payload,
    });
  };

export const fetchPopularSuggestions =
  () => (dispatch: Dispatch, getState: any) => {
    const { remoteConfig } = getState();
    return getPopularSuggestions(remoteConfig)
      .then((res) => {
        dispatch({
          type: actions.FETCH_POPULAR_SUGGESTIONS,
          payload: res,
        });
      })
      .catch((e) => {
        dispatch({
          type: actionTypes.FETCH_POPULAR_SUGGESTIONS_FAIL,
        });
        logger.error(e, 'Error in fetch popular suggestions');
        throw e;
      });
  };

export const fetchRecentlyViewedProducts =
  (productIds: string = '') =>
  (dispatch: Dispatch) =>
    getBulkProducts(productIds)
      .then((productData) => {
        dispatch({
          type: actions.FETCH_RECENTLY_VIEWED_PRODUCTS,
          payload: productData,
        });
      })
      .catch((e) => {
        dispatch({
          type: actionTypes.FETCH_POPULAR_SUGGESTIONS_FAIL,
        });
        logger.error(e, 'Error in fetch popular suggestions');
        throw e;
      });

export const fetchSearchSuggestionWidgets =
  (params: { [key: string]: string }, isPaginationEnabled?: boolean) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: actionTypes.FETCH_SEARCH_SUGGESTION_WIDGETS_PROGRESS,
    });
    const requestParams = {
      ...params,
    };
    return getWidgets(requestParams, '', isPaginationEnabled)
      .then(({ widgets, remaining_inventories_ids }) => {
        dispatch({
          type: actionTypes.FETCH_SEARCH_SUGGESTION_WIDGETS_SUCCESS,
          payload: {
            widgets,
            remaining_inventories_ids,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.FETCH_SEARCH_SUGGESTION_WIDGETS_FAIL,
        });
        logger.error(err, 'Error in Fetch Widgets action for search query');
      });
  };
